'use client'

import { FC } from 'react'

import Link from '@/components/Link'
import CaseStudyChallenge from '@/sections/CaseStudyChallenge'

const FortoChallenge: FC<{}> = () => {
    return (
        <CaseStudyChallenge
            paragraph={
                <>
                    Leading digital freight forwarder, Forto, is on a mission to make global
                    shipping as simple as sending an email. With customers ranging from solar
                    companies like Enpal to manufacturers like Octo Actuators, Forto sits at the
                    heart of global trade between Asia and Northern Europe.
                    <br />
                    <br />
                    As the logistics industry faced growing pressure to cut emissions by{' '}
                    <Link
                        href="https://lune.co/blog/what-is-carbon-insetting"
                        color="Grey900"
                        newPage
                        sx={{ textDecoration: 'underline' }}
                    >
                        scaling biofuels
                    </Link>
                    , Forto saw a strategic opportunity to step forward as a sustainability leader.
                    <br />
                    <br />
                    To do so, they needed emissions data that was reliable, transparent, and
                    credible — the foundation for both customer trust and competitive advantage.
                </>
            }
            imageSrc={'/images/forto-case-study/forto-challenge.png'}
        />
    )
}

export default FortoChallenge
